import React from "react";
import { Chip, Tooltip } from "@mui/material";
import type { ClientRunStatus } from "features/integrationsBeta/integrationsBeta";
import {
  PASTEL_CHIP_BASE_SX,
  clientRunStatusChipSx,
} from "features/integrationsBeta/platformEnumUi";

type Props = {
  status: ClientRunStatus | null | undefined;
  /** Label from the backend catalog (GET /runs/client-statuses/). */
  label: string;
  size?: "small" | "medium";
  tooltip?: React.ReactNode;
};

/**
 * The client-facing status pill (CAL-5776) - the ONE place that maps a
 * client status to its look, shared by the internal history and the client
 * history so the two can never disagree. It renders the status exactly as
 * the client sees it, with no mark of who set it or how (CAL-6165): that is
 * internal detail and lives in the tooltip an internal surface passes.
 */
export default function ClientRunStatusChip({
  status,
  label,
  size = "small",
  tooltip,
}: Props) {
  if (!status) {
    return <span aria-label="No client status">—</span>;
  }
  const chip = (
    <Chip
      label={label}
      size={size}
      sx={{
        ...PASTEL_CHIP_BASE_SX,
        minWidth: 100,
        ...(clientRunStatusChipSx(status) as object),
      }}
    />
  );
  if (!tooltip) return chip;
  return (
    <Tooltip title={tooltip} disableInteractive>
      <span style={{ display: "inline-flex" }}>{chip}</span>
    </Tooltip>
  );
}
